export enum QuestionnaireId {
  MOCK = 'mock',
  SLEEP_APNEA = 'sleep-apnea',
  EXTREME_ACTIVITIES = 'extreme-activities',
  DIABETES = 'diabetes',
  SPECIAL_TRAVEL = 'special-travel',
  DRUG_USE = 'drug-use',
  NERVOUS_DISORDERS = 'nervous-disorders',
  MAIN = 'main', // Used for main questionnaires
  DETAILS = 'details', // Used to automatically generate a DetailsQuestionnaire
}
